export default "__VITE_ASSET__Cij45YVa__"